<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  components: { ContentLoader },
};
</script>

<template>
  <content-loader
    width="1276"
    height="430"
    viewBox="0 0 1276 524"
    :speed="2"
    primaryColor="#F9FAFF"
    secondaryColor="#D8DFF6"
    :primaryOpacity="0.9"
    :secondaryOpacity="0.25"
  >
    <rect x="48" y="362" width="151" height="83" rx="4" />
    <rect x="366" y="363" width="151" height="83" rx="4" />
    <rect x="684" y="364" width="151" height="83" rx="4" />
    <rect x="1002" y="365" width="151" height="83" rx="4" />
    <rect x="47" y="455" width="152" height="20" rx="4" />
    <rect x="365" y="456" width="152" height="20" rx="4" />
    <rect x="683" y="457" width="152" height="20" rx="4" />
    <rect x="1001" y="458" width="152" height="20" rx="4" />
    <rect x="48" y="60" width="7" height="265" rx="3.5" />
    <rect x="59" y="60" width="258" height="266" />
    <path
      d="M330 145.007V61.0621C330 60.4861 330.468 60.0285 331.044 60.0598C372.705 62.3254 444.304 51.9583 480.5 47C509.293 43.0557 562.168 41.3802 586.007 41.0147C586.565 41.0062 587 41.4565 587 42.0144V126.5V127.974C587 128.536 586.531 128.988 585.968 128.974C528.961 127.62 484.236 137.527 440.5 142C405.804 145.548 353.684 146.15 330.971 146.007C330.421 146.003 330 145.557 330 145.007Z"
    />
    <path
      d="M873 61.0112V111.385C873 111.951 873.454 112.405 874.02 112.387C915.671 111.07 986.797 121.478 1023 124.5C1051.8 126.904 1105.16 130.69 1129.01 130.99C1129.57 130.997 1130 130.547 1130 129.991V127.949V109.924V81.8986V81.3912C1130 80.8327 1129.54 80.3827 1128.98 80.3896C1071.97 81.0988 1027.24 65.1792 983.5 62.4533C948.805 60.291 896.688 59.9245 873.973 60.0117C873.423 60.0138 873 60.4607 873 61.0112Z"
    />
    <path
      d="M858.5 39.0001H603C602.448 39.0001 602 39.4479 602 40.0001V104.506C602 105.056 602.444 105.503 602.994 105.506L858.494 106.994C859.049 106.998 859.5 106.549 859.5 105.994V40.0001C859.5 39.4479 859.052 39.0001 858.5 39.0001Z"
    />
    <path
      d="M714.5 113.5C688.027 107.968 629.776 108.486 602.978 108.5C602.425 108.5 602 108.948 602 109.5V130.466C602 131.031 602.466 131.484 603.032 131.475C613.85 131.298 643.809 133.226 682.5 134C732.5 135 726 142 763.5 147.5C793.012 151.828 838.493 150.706 858.528 150.509C859.077 150.504 859.5 150.058 859.5 149.509V133C859.5 132.448 859.052 132 858.5 132H852C804.5 133.5 748 120.5 714.5 113.5Z"
    />
    <path
      d="M1129 39.0001H874C873.448 39.0001 873 39.4479 873 40.0001V56.4961C873 57.0499 873.45 57.4982 874.004 57.4961L1129 56.5039C1129.55 56.5017 1130 56.0546 1130 55.5039V40.0001C1130 39.4479 1129.55 39.0001 1129 39.0001Z"
    />
    <path
      d="M498 151C472.985 151 378.239 149.029 332.996 148.022C332.435 148.01 332 148.462 332 149.023V324.5C332 325.052 332.448 325.5 333 325.5H588C588.552 325.5 589 325.052 589 324.5V152C589 151.448 588.571 151 588.019 151H498Z"
    />
    <path
      d="M987.5 139.5C963.796 134.364 903.347 132.87 876.007 132.031C875.443 132.014 875 132.467 875 133.032V144.034C875 144.573 875.408 145.014 875.947 145.033C895.62 145.736 939.845 147.852 967 151C1001.5 155 1032.5 164.5 1058 166C1077.97 167.175 1114.28 169.085 1130.96 169.946C1131.53 169.976 1132 169.52 1132 168.947V159.522C1132 158.961 1131.55 158.51 1130.99 158.506C1122.48 158.448 1100.29 155.857 1060 152.5C1022.6 149.383 1017.5 146 987.5 139.5Z"
    />
    <path
      d="M963 171C937.843 162.841 896.289 155.72 876.407 154.073C875.886 154.03 875.5 153.597 875.5 153.074V148.5C875.5 147.948 875.944 147.5 876.497 147.516C881.598 147.658 893.87 148.75 909.5 150C934.5 152 946.5 156 979.5 168.5C1012.5 181 1025.5 191 1053 205C1074.63 216.013 1114.96 220.838 1133.57 221.947C1134.1 221.979 1134.5 222.416 1134.5 222.947V227C1134.5 227.552 1134.05 228 1133.5 228H1122C1112 228 1074 222 1048.73 210.818C1014.58 195.707 981.5 177 963 171Z"
    />
    <rect x="593" y="152" width="7" height="172" rx="3.5" />
    <rect x="320" y="62" width="7" height="264" rx="3.5" />
    <rect x="590" y="39" width="7" height="90" rx="3.5" />
    <rect x="863" y="42" width="6" height="69" rx="3" />
    <rect x="863" y="132" width="6" height="21" rx="3" />
    <rect x="1135" y="42" width="7" height="18" rx="3.5" />
    <rect x="1134" y="82" width="7" height="52" rx="3.5" />
    <rect x="1134" y="158" width="7" height="11" rx="3.5" />
    <rect x="1136" y="223" width="7" height="8" rx="3.5" />
  </content-loader>
</template>
